/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IBreadcrumbsViewProps } from './breadcrumbs';

export default (props: IBreadcrumbsViewProps) => {
    const routes = props.app.routes;
    return (
        <section aria-label='Breadcrumbs (current location)' className='Breadcrumbs'>
            <div className='ContentWrapper'>
                <nav aria-label='Breadcrumbs navigation'>
                    <ul itemScope itemType='http://schema.org/BreadcrumbList' className='Breadcrumbs-List'>
                        <li itemProp='itemListElement' itemScope itemType='http://schema.org/ListItem' className='Breadcrumb'>
                            <a tabIndex={-1} href={routes.home.destinationUrl} className='Breadcrumb-Link'>
                                <meta itemProp='item' content='/' />
                                <span itemProp='name'>Home</span>
                                <meta itemProp='position' content='0' />
                            </a>
                        </li>
                        <li itemProp='itemListElement' itemScope itemType='http://schema.org/ListItem' className='Breadcrumb'>
                            <div tabIndex={-1}>
                                <meta itemProp='item' content='/' />
                                <span itemProp='name'>{props.config.path}</span>
                                <meta itemProp='position' content='1' />
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
        </section>
    );
};
